
import { useContext, useEffect, useRef, useState } from "react";

import { findAnswersByQuestionId, findQuestionsByViewId, validateAnswers } from "../../../lib/helper";

import { AnswerContext } from "../../../state/answers";

import { ViewContext } from "../../../state/view";

import { Button } from "../../../components/button";

import { Form } from "../../../components/form";

import {

  Question,

  QuestionHeader,

  QuestionLabel,

  QuestionKicker,

  QuestionNumber

} from "../../../components/question";

import { Required } from "../../../components/required";

import { Answers } from "./components/answers";

export function Phase( { cardRef } ) {

  const { selectedAnswers } = useContext( AnswerContext );
  
  const { view, updateView } = useContext( ViewContext );

  const [ cardPadding, setCardPadding ] = useState( { top: 0, bottom: 0 } )

  const [ questions, setQuestions ] = useState( findQuestionsByViewId( view ) );

  const formRef = useRef( null );

  const questionIds = questions.map( question => question.id );

  const viewAnswers = selectedAnswers?.filter( answer => questionIds.includes( answer.question_id ) );

  const handleSubmit = e => {

    e.preventDefault();

    const updatedQuestions = questions.map( question => {

      const matchedAnswer = viewAnswers.find( answer => answer.question_id === question.id );

      return matchedAnswer ? { ...question, answers: matchedAnswer.answers } : question;
      
    } ) ;

    setQuestions( updatedQuestions );

    const answersInvalid = updatedQuestions.map( question => validateAnswers( question.answers ) ).some( valid => valid );

    if ( answersInvalid ) {

      if ( formRef.current && cardPadding.top ) {
        
        const elementPosition = formRef.current.getBoundingClientRect().top;

        const offsetPosition = elementPosition + window.scrollY - cardPadding.top;

        window.scrollTo( { top: offsetPosition, behavior: 'smooth' } );

      }

      return;

    }

    updateView( prevViewId => prevViewId + 1 );

  }

  const handlePrevious = e => {

    e.preventDefault();

    updateView( prevViewId => prevViewId - 1 );

  }

  useEffect( () => {

    const newQuestions = findQuestionsByViewId( view );

    setQuestions( newQuestions );

  }, [ view ] );

  useEffect( () => {

    if ( cardRef.current ) {

      const { paddingTop, paddingBottom } = getComputedStyle( cardRef.current );

      setCardPadding( {

        top: paddingTop.replace( 'px', '' ),

        bottom: paddingBottom.replace( 'px', '' ),

      } );

    }

  }, [] );

  return (

    <Form onSubmit={ handleSubmit } className="border-l border-grey-silver relative mb-12 sm:mb-14" ref={ formRef }>
      
      { questions.map( question => (

        <Question key={ question?.id }>

          <QuestionNumber>{ question?.id }</QuestionNumber>

          <QuestionHeader>

            <QuestionLabel>
              
              { question?.label }
              
              <Required />
              
            </QuestionLabel>

            <QuestionKicker>{ question?.kicker }</QuestionKicker>

          </QuestionHeader>

          <Answers 
          
            answers={ findAnswersByQuestionId( question.id ) }
            
            question={ question }
            
          />

        </Question>

      ) ) }

      <div className="absolute translate-y-1/2 flex gap-4 sm:gap-8 lg:gap-12" style={ { top: `calc(100% + ${ cardPadding.bottom }px)` } }>

        { view > 1 && 

          <Button size="large" onClick={ handlePrevious }>

            Previous

          </Button>

        }

        <Button size="large" type="submit">

          Continue

        </Button>

      </div>

    </Form>

  )

}
